import {IAuthenticationService} from "../../domain/server/IAuthenticationService";
import {ApiAccessService} from "../api/ApiAccessService";

export class AuthenticationService implements IAuthenticationService{

    private apiAccessService:ApiAccessService;
    private isUserAdmin:boolean;

    constructor(apiAccessService:ApiAccessService){
        this.apiAccessService = apiAccessService;
        this.isUserAdmin = false;
    }

    public Authenticate(password: string): Promise<void> {
        return this.apiAccessService.Authenticate(password).then(() => {
            this.isUserAdmin = true;
        });
    }

    public IsUserAdmin(): boolean {
        return this.isUserAdmin;
    }
}


// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/infrastructure/server/AuthenticationService.ts